import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { selectQuoteDetails } from "../../redux/selector";
import { quotesActions } from "../../redux/slice";
import Accessories from "./OpenBoxQuotes/Accessories";
import BoxStructure from "./OpenBoxQuotes/BoxStructure";
import QuoteCosts from "./OpenBoxQuotes/QuoteCosts";
import QuoteFloor from "./OpenBoxQuotes/QuoteFloor";
import Standard from "./OpenBoxQuotes/Standard";
import SummaryBar from "./OpenBoxQuotes/SummaryBar";
import { useStyles } from "./styles";

interface QuotesDetailsProps {
  quoteId: string;
}

const QuotesDetails = ({ quoteId }: QuotesDetailsProps) => {
  const { i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const quoteDetails = useSelector(selectQuoteDetails);

  useEffect(() => {
    dispatch(quotesActions.getQuoteDetails(quoteId));

    return () => {
      dispatch(quotesActions.clearQuoteDetails());
    };
  }, [dispatch, quoteId]);

  return (
    <Box className={styles.root} dir={i18n.dir()}>
      <SummaryBar data={quoteDetails} />
      <QuoteCosts />
      <QuoteFloor />
      <BoxStructure />
      <Accessories />
      <Standard />
    </Box>
  );
};

export default QuotesDetails;
